<template>
  <div class="public">
    <v-layout>
      <v-card
        style="max-width: 400px; margin: auto; width:100%"
        ref="card"
      >
        <Center>
        <img src="../assets/logo-long.png"/><br>
          <h2>Client Portal</h2>
        </Center>
        <router-view/>
      </v-card>
    </v-layout>
  </div>
</template>

<style>
  .public {
    background-color: #ccc;
    height: 100vh;
    width: 100%;
    padding:30px;
  }

  .public .v-card {
    padding:20px;
  }

  @media screen and (max-width: 400px) {
    .public {
      padding:10px;
    }
  }

</style>

<script>
export default {
  name: 'Public',
  mounted() {
    if (this.$router.currentRoute.name === 'Public') {
      this.$router.push({ path: '/public/login', query: this.$route.query });
    }
  },
};
</script>
